import ApiBase from 'Services/Api/ApiBase';

class CovidTestEntry extends ApiBase {
    route = '/covid/covid-test-entry';
};

export default new CovidTestEntry();